import { createSlice } from "@reduxjs/toolkit";
import { ReducerEntityPrefixTypes, ReducerNamespaceTypes } from "enums";
import { getPrefix } from "features/Application/slices/models";

interface AccountDependencies {
  hasChildAccounts: boolean;
  hasAssignedPacks: boolean;
  state: "idle" | "loading" | "fetched";
}

const initialState: AccountDependencies = {
  hasChildAccounts: false,
  hasAssignedPacks: false,
  state: "idle",
};

const slice = createSlice({
  name: getPrefix({
    namespace: ReducerNamespaceTypes.Accounts,
    entity: ReducerEntityPrefixTypes.Accounts,
    name: "accountDependencies",
  }),
  initialState,
  reducers: {
    setDependencies(state, action: { payload: { hasChildAccounts: boolean; hasAssignedPacks: boolean } }) {
      state.hasChildAccounts = action.payload.hasChildAccounts;
      state.hasAssignedPacks = action.payload.hasAssignedPacks;
    },
    setState(state, action: { payload: AccountDependencies["state"] }) {
      state.state = action.payload;
    },
    resetState() {
      return initialState;
    },
  },
});

export const { setDependencies, setState, resetState } = slice.actions;

export default slice.reducer;
